import styles from "./claimBonus.module.css";

const claimBonusPointsStyle ={
    outerContainer: `bg-themeColor rounded-[10px] flex flex-col py-[10px] px-[15px] gap-[8px] w-full max-h-[250px] overflow-auto `,
    headerContainer: `flex justify-between items-center`,
    heading: `text-[17px] font-Suisse font-[700] capitalize ${styles.bonusheading}`,
    dividerContainer: `flex gap-2`,
    divider: `bg-primaryHeading h-[2px]`,
    button: `rounded-[4px] !px-[6px] !py-[3px] min-w-[100px] !text-[14px]`,
    componentContainer: `max-h-[200px] flex flex-col gap-2 overflow-auto`,
    emptyContainer: `w-full flex flex-col items-center justify-center`,
    loaderContainer: `w-full flex flex-col items-center justify-center`,
}

const bonusPointsContainerStyle = {
    outerContainer: `flex flex-col gap-[10px] justify-between bg-themeOverlay rounded-[10px] p-[10px]  w-[98%] 
                    md:flex-row md:gap-0 md:items-center ${styles.outerContainer}`,
    bonusPoint: `flex gap-[12px] flex-row items-center`,
    image: `max-h-[40px] max-w-[40px] min-h-[40px] min-w-[40px] flex items-center justify-center ${styles.image}`,
    bonusDetails: `flex flex-col`,
    heading: `font-Suisse text-[15px] font-[700] ${styles.heading}`,
    subHeading: `text-primaryHeading text-[12px] ${styles.subHeading}`,
    button: `rounded-[4px] !text-[14px] !rounded-[4px] !px-[6px] !py-[3px] md:min-w-[100px] ${styles.claimbutton}`,

}
export { claimBonusPointsStyle, bonusPointsContainerStyle } 